var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.315 0h.593l7.11 8.296V29.64c0 1.296-1.059 2.36-2.366 2.36H2.868a2.37 2.37 0 01-2.367-2.379V2.38A2.376 2.376 0 012.875 0h12.441L15.315 0zm-.593 1.185H2.866c-.652 0-1.18.54-1.18 1.18v27.27c0 .651.539 1.179 1.185 1.179h17.777c.655 0 1.185-.528 1.185-1.177V9.48H17.09a2.365 2.365 0 01-2.368-2.377V1.184v.001zm1.186.593V7.1c0 .66.534 1.196 1.181 1.196h4.389l-5.57-6.518z",
    fill: "#9B9B9B",
    fillRule: "nonzero"
  })));
}
export default SvgFile;